export default function getDateForSnackbar() {
  var d = new Date(); // for now
  d.getHours();
  d.getMinutes();
  // console.log("print", d.getHours() + ":" + d.getMinutes());
  return d.getHours() + ":" + d.getMinutes();
}
